import Swiper from 'swiper/bundle';


if ($('.slider-logos').length) {
	$('.slider-logos').each(function() {
		var slides = $(this).find('.swiper-slide').length;
		var thisSlider = $(this);
		// console.log(slides)
		window.sliderLogos = new Swiper($(this)[0], {
			slidesPerView: slides <= 3 ? slides : 3,
			allowTouchMove: false,
			spaceBetween: 16,
			speed: 6000,
			centeredSlides: false,
			autoplay: {
				enabled: slides > 3 ? true : false,
				delay: 1,
			},
			loop: slides > 3 ? true : false,
			// loopAdditionalSlides: slides,
			loopedSlides: slides,
			breakpoints: {
				480: {
					slidesPerView: slides <= 3 ? slides : 3,
					autoplay: {
						enabled: slides > 3 ? true : false,
						delay: 1,
					},
					loop: slides > 3 ? true : false,
				},
				640: {
					slidesPerView: slides <= 4 ? slides : 'auto',
					autoplay: {
						enabled: slides > 4 ? true : false,
						delay: 1,
					},
					loop: slides > 4 ? true : false,
				},
				768: {
					slidesPerView: slides <= 5 ? slides : 'auto',
					autoplay: {
						enabled: slides > 5 ? true : false,
						delay: 1,
					},
					loop: slides > 5 ? true : false,
				},
				1024: {
					spaceBetween: 32,
					slidesPerView: slides <= 7 ? slides : 'auto',
					centeredSlides: slides > 7 ? true : false,
					autoplay: {
						enabled: slides > 7 ? true : false,
						delay: 1,
					},
					loop: slides > 7 ? true : false,
				},
				1280: {
					spaceBetween: 32,
					slidesPerView: slides <= 8 ? slides : 'auto',
					centeredSlides: slides > 8 ? true : false,
					autoplay: {
						enabled: slides > 8 ? true : false,
						delay: 1,
					},
					loop: slides > 8 ? true : false,
				},
				1696: {
					spaceBetween: 32,
					slidesPerView: slides <= 10 ? slides : 'auto',
					centeredSlides: slides > 10 ? true : false,
					autoplay: {
						enabled: slides >= 10 ? true : false,
						delay: 1,
					},
					loop: slides >= 10 ? true : false,
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
					logosSlidesCheck(slides, thisSlider);
				},
				resize: function (swiper) {
					sliderLogos.update();
					logosSlidesCheck(slides, thisSlider);
				},
			},
		});
	})
}

function logosSlidesCheck(slides, slider) {
	// console.log('slides ' + slides)
	var insufficient = false;
	if ($(window).width() >= 1696) {
		if (slides < 11) {
			insufficient = true;
		} else {
			insufficient = false;
		}
	} else if ($(window).width() >= 1280) {
		if (slides < 9) {
			insufficient = true;
		} else {
			insufficient = false;
		}
	} else if ($(window).width() >= 1024) {
		if (slides < 7) {
			insufficient = true;
		} else {
			insufficient = false;
		}
		
	} else if ($(window).width() >= 768) {
		if (slides < 6) {
			insufficient = true;
		} else {
			insufficient = false;
		}
		
	} else if ($(window).width() >= 640) {
		if (slides < 5) {
			insufficient = true;
		} else {
			insufficient = false;
		}	
	} else if ($(window).width() >= 480) {
		if (slides < 4) {
			insufficient = true;
		} else {
			insufficient = false;
		}	
	} else {
		if (slides < 3) {
			insufficient = true;
		} else {
			insufficient = false;
		}	
	}

	// console.log('insufficient ' + insufficient)
	if (insufficient) {
		slider.addClass('insufficient-slides');
	} else {
		slider.removeClass('insufficient-slides');
	}
}





if ($('.slider-type-1').length) {
	$('.slider-type-1').each(function() {
		window.sliderType1 = new Swiper($(this)[0], {
			slidesPerView: 1.25,
			centeredSlides: false,
			spaceBetween: 16,
			speed: 600,
			autoplay: false,
			loop: false,
			scrollbar: {
				el: $(this).closest('section').find('.swiper-scrollbar')[0],
				draggable: true,
			},
			navigation: {
				nextEl: $(this).closest('section').find('.swiper-button-next')[0],
				prevEl: $(this).closest('section').find('.swiper-button-prev')[0],
			},
			breakpoints: {
				480: {
					slidesPerView: 1.5,
				},
				640: {
					slidesPerView: 2.25,
				},
				768: {
					slidesPerView: 2.5,
				},
				1024: {
					slidesPerView: 3.25,
					spaceBetween: 24,
				},
				1280: {
					slidesPerView: 3.75,
					spaceBetween: 32,
				},
				1696: {
					slidesPerView: 4.25,
					spaceBetween: 32,
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	})
}


if ($('.slider-type-2-image').length) {
	$('.slider-type-2-image').each(function() {
		var section = $(this).closest('section');
		window.sliderType2Image = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoplay: false,
			loop: true,
			watchSlidesProgress: true,
			touchEventsTarget: 'wrapper',
			allowTouchMove: false,
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
				slideChangeTransitionStart: function (swiper) {
					section.find('.column-progress .current').text(swiper.realIndex + 1);
				},
			},
		});
	})
}
if ($('.slider-type-2-text').length) {
	$('.slider-type-2-text').each(function() {
		window.sliderType2Text = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoplay: false,
			loop: true,
			touchEventsTarget: 'wrapper',
			watchSlidesProgress: true,
			navigation: {
				nextEl: $(this).closest('section').find('.swiper-button-next')[0],
				prevEl: $(this).closest('section').find('.swiper-button-prev')[0],
			},
			thumbs: {
			  	swiper: sliderType2Image,
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	})
}


if ($('.slider-type-3-image').length) {
	$('.slider-type-3-image').each(function() {
		window.sliderType3Image = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoplay: false,
			loop: false,
			watchSlidesProgress: true,
			touchEventsTarget: 'wrapper',
			allowTouchMove: false,
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	})
}
if ($('.slider-type-3-text').length) {
	$('.slider-type-3-text').each(function() {
		var section = $(this).closest('section');
		window.sliderType3Text = new Swiper($(this)[0], {
			slidesPerView: 1,
			autoHeight: true,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoplay: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			watchSlidesProgress: true,
			navigation: {
				nextEl: $(this).closest('section').find('.swiper-button-next')[0],
				prevEl: $(this).closest('section').find('.swiper-button-prev')[0],
			},
			thumbs: {
			  	swiper: sliderType3Image,
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
				slideChangeTransitionStart: function (swiper) {
					section.find('.column-progress .current').text(swiper.realIndex + 1);
				},
			},
		});
	})
}